/**
 * @flow
 * @relayHash 97bf2ae4fadf725a9cb00e207fef7e17
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type AddLotInput = {|
  lotNumber: string,
  binNumber?: ?string,
  expiresAt?: ?any,
  warehouseLocationId?: ?string,
|};
export type AddLotMutationVariables = {|
  input: AddLotInput
|};
export type AddLotMutationResponse = {|
  +addLot: {|
    +lotEdge: {|
      +node: {|
        +id: string,
        +lotNumber: string,
        +binNumber: ?string,
        +expiresAt: ?any,
        +warehouseLocation: ?{|
          +id: string,
          +name: string,
        |},
      |}
    |}
  |}
|};
export type AddLotMutation = {|
  variables: AddLotMutationVariables,
  response: AddLotMutationResponse,
|};
*/


/*
mutation AddLotMutation(
  $input: AddLotInput!
) {
  addLot(input: $input) {
    lotEdge {
      node {
        id
        lotNumber
        binNumber
        expiresAt
        warehouseLocation {
          id
          name
        }
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "AddLotInput!",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "addLot",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "AddLotPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "lotEdge",
        "storageKey": null,
        "args": null,
        "concreteType": "LotEdge",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "Lot",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "lotNumber",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "binNumber",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "expiresAt",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "warehouseLocation",
                "storageKey": null,
                "args": null,
                "concreteType": "WarehouseLocation",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "name",
                    "args": null,
                    "storageKey": null
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "AddLotMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v2/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "AddLotMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v2/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "AddLotMutation",
    "id": null,
    "text": "mutation AddLotMutation(\n  $input: AddLotInput!\n) {\n  addLot(input: $input) {\n    lotEdge {\n      node {\n        id\n        lotNumber\n        binNumber\n        expiresAt\n        warehouseLocation {\n          id\n          name\n        }\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'bd9c564e5543ad1cb3c3251343fbebf4';
module.exports = node;
